import { fillerColDef } from "@/lib/fillerColDef";
import { returnSizeFormatted } from "@/lib/globalFormatterHelper";
import { defaultColumnWidths } from "@/lib/interfaces and Enums/ENUMColumnWidths";
import { TableHeaderField } from "@/lib/interfaces and Enums/ENUMTableHeaders";
import { ColDef } from "ag-grid-community";
import RiskDV01CellRenderer from "../cellRenderers/RiskDV01CellRenderer";

export function returnCreationTableDetailColDefs(fullBlockData: any) {
  const creationTableDetailColDefs: (ColDef & Record<string, any>)[] = [
    {
      checkboxSelection: true,
      width: defaultColumnWidths.checkbox,
      resizable: false,
      suppressMovable: true,
      pinned: "left",
      suppressColumnsToolPanel: true,
    },
    {
      field: "portfolio",
      headerName: TableHeaderField.portfolio,
      width: defaultColumnWidths.portfolio,
    },
    {
      field: "notionalLeg1",
      headerName: TableHeaderField.notionalLeg1,
      width: defaultColumnWidths.nominal,
      valueFormatter: (params: any) => {
        if (params.value && fullBlockData && fullBlockData.instrumentType) {
          return returnSizeFormatted(
            params.value,
            fullBlockData.instrumentType,
          );
        } else {
          return "";
        }
      },
    },
    {
      field: "complianceStatus",
      headerName: TableHeaderField.complianceStatus,
      extraScaling: true,
      width: defaultColumnWidths.complianceStatus,
    },
    {
      field: "dV01",
      headerName: TableHeaderField.dV01,
      cellDataType: "number",
      cellRenderer: RiskDV01CellRenderer,
      width: defaultColumnWidths.dv01,
      cellRendererParams: { instrumentType: fullBlockData.instrumentType },
    },
    ...fillerColDef,
  ];

  return creationTableDetailColDefs;
}
